import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { CodeLayout, CodeViewer, MermaidViewer, CodeDescription, WhiteColumnLayout, LayoutColumn, WhiteLayout } from "netcompany-mdx-slide";
import code_structure from "./assets/code_structure.png";
import loc_analysis from "./assets/loc_analysis.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <WhiteColumnLayout title={"The case study"} sizes={[3, 4]} colors={['#fff', '#0f2147']} texts={['#0f2147', '#fff']} mdxType="WhiteColumnLayout">
      <LayoutColumn mdxType="LayoutColumn">
        <h3>{`Conclusion`}</h3>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Well-organized project`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to locate the issue`}</p>
          </li>
        </ul>
      </LayoutColumn>
      <LayoutColumn mdxType="LayoutColumn">
        <div style={{
          objectFit: 'contain',
          overflow: "hidden",
          display: "flex",
          flexDirection: "row",
          flex: "1"
        }}>
  <img src={code_structure} alt="code_structure" />
        </div>
      </LayoutColumn>
    </WhiteColumnLayout>
    <hr></hr>
    <WhiteColumnLayout title={"The case study"} sizes={[3, 4]} colors={['#fff', '#0f2147']} texts={['#0f2147', '#fff']} mdxType="WhiteColumnLayout">
      <LayoutColumn mdxType="LayoutColumn">
        <h3>{`Conclusion`}</h3>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Well-organized project`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to locate the issue`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to comprehend and start coding`}</p>
          </li>
        </ul>
      </LayoutColumn>
      <LayoutColumn mdxType="LayoutColumn">
        <div style={{
          display: "flex",
          flex: 1,
          width: "100%",
          flexDirection: "column"
        }}>
          <CodeViewer mdxType="CodeViewer">
            <pre><code parentName="pre" {...{
                "className": "language-java",
                "metastring": "5:13 file=../src/main/java/com/netcompany/core/Menu.java",
                "5:13": true,
                "file": "../src/main/java/com/netcompany/core/Menu.java"
              }}>{`package com.netcompany.core;

import java.util.List;

public interface Menu {
    List<MenuItem> getMenuItems();

    String getMenuHeader();

    String getBackItemName();

    void launch();
}
`}</code></pre>
            <pre><code parentName="pre" {...{
                "className": "language-java",
                "metastring": "3:7 file=../src/main/java/com/netcompany/core/MenuItem.java",
                "3:7": true,
                "file": "../src/main/java/com/netcompany/core/MenuItem.java"
              }}>{`package com.netcompany.core;

public interface MenuItem {
    String getItemName();

    void launch();
}
`}</code></pre>
            <pre><code parentName="pre" {...{
                "className": "language-java",
                "metastring": "9:31 file=../src/main/java/com/netcompany/service/CourseService.java",
                "9:31": true,
                "file": "../src/main/java/com/netcompany/service/CourseService.java"
              }}>{`package com.netcompany.service;

import java.util.List;

import com.netcompany.dto.ValidationResult;
import com.netcompany.entity.Course;
import com.netcompany.exception.ValidationException;

public interface CourseService {
    Course findCourseByCode(String code);

    ValidationResult checkValidCourseCode(String courseCode);

    ValidationResult checkNotExistCourseCode(String courseCode);

    ValidationResult checkExistCourseCode(String courseCode);

    ValidationResult checkCourseGrade(Float gradeValue);

    void addNewCourse(Course course) throws ValidationException;

    void updateCourse(Course course) throws ValidationException;

    Course removeCourse(String courseCode) throws ValidationException;

    void cleanCourseGrade(String courseCode) throws ValidationException;

    List<Course> getAll();

}
`}</code></pre>
          </CodeViewer>
        </div>
      </LayoutColumn>
    </WhiteColumnLayout>
    <hr></hr>
    <WhiteColumnLayout title={"The case study"} sizes={[3, 4]} colors={['#fff', '#0f2147']} texts={['#0f2147', '#fff']} mdxType="WhiteColumnLayout">
      <LayoutColumn mdxType="LayoutColumn">
        <h3>{`Conclusion`}</h3>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Well-organized project`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to locate the issue`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to comprehend and start coding`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to find and re-use a logic`}</p>
          </li>
        </ul>
      </LayoutColumn>
      <LayoutColumn mdxType="LayoutColumn">
        <div style={{
          display: "flex",
          flex: 1,
          width: "100%",
          flexDirection: "column"
        }}>
          <CodeViewer mdxType="CodeViewer">
            <pre><code parentName="pre" {...{
                "className": "language-java",
                "metastring": "8:46 file=../src/main/java/com/netcompany/core/AbstractMenu.java showNumbers zoomIn=1.3",
                "8:46": true,
                "file": "../src/main/java/com/netcompany/core/AbstractMenu.java",
                "showNumbers": true,
                "zoomIn": "1.3"
              }}>{`package com.netcompany.core;

import java.util.ArrayList;
import java.util.List;
import java.util.Scanner;
import java.util.regex.Pattern;

public abstract class AbstractMenu implements Menu {
    private static final Pattern numericPattern = Pattern.compile("^\\\\d+$");
    protected ConsoleContext appCtx;
    protected List<MenuItem> menuItems;

    public AbstractMenu(ConsoleContext appCtx) {
        this.appCtx = appCtx;
        this.menuItems = new ArrayList<>();
    }

    @Override
    public List<MenuItem> getMenuItems() {
        return this.menuItems;
    }

    @Override
    public void launch() {
        String userChoise = null;
        int index;
        int userChoiseInt = 0;
        Scanner scanner = this.appCtx.getScanner();
        do {
            System.out.println(this.getMenuHeader());
            index = 1;
            for (MenuItem menuItem : this.getMenuItems()) {
                System.out.println(String.format("%d. %s", index, menuItem.getItemName()));
                index++;
            }
            System.out.println(String.format("0. %s", this.getBackItemName()));
            do {
                System.out.print(this.getSelectInstruction());
                userChoise = scanner.nextLine();
            } while (!this.checkUserChoise(userChoise));
            userChoiseInt = Integer.parseInt(userChoise);
            if (userChoiseInt != 0) {
                this.launchMenuItem(userChoiseInt - 1);
            }
        } while (userChoiseInt != 0);
    }

    protected String getSelectInstruction() {
        return "Enter your choise: ";
    }

    protected void launchMenuItem(int index) {
        this.getMenuItems()
                .get(index)
                .launch();
    }

    private boolean checkUserChoise(String userChoise) {
        if (!numericPattern.matcher(userChoise).find()) {
            System.out.println("Invalid choise: the choise must be integer and follow instruction above.");
            return false;
        }
        int userChoiseValue = Integer.parseInt(userChoise);
        if (userChoiseValue < 0 || userChoiseValue > this.getMenuItems().size()) {
            System.out.println(
                    String.format("Invalid choise: the choise must between 0 and %d", this.getMenuItems().size()));
            return false;
        }
        return true;
    }
}
`}</code></pre>
            <pre><code parentName="pre" {...{
                "className": "language-java",
                "metastring": "8:31 file=../src/main/java/com/netcompany/menu/manageGrade/ManageGradeMenu.java zoomIn=1.5",
                "8:31": true,
                "file": "../src/main/java/com/netcompany/menu/manageGrade/ManageGradeMenu.java",
                "zoomIn": "1.5"
              }}>{`package com.netcompany.menu.manageGrade;

import com.netcompany.commonFeature.ShowCourseFeature;
import com.netcompany.core.AbstractMenu;
import com.netcompany.core.ConsoleContext;
import com.netcompany.core.MenuItem;

public class ManageGradeMenu extends AbstractMenu implements MenuItem {
    public ManageGradeMenu(ConsoleContext appCtx) {
        super(appCtx);
        this.menuItems.add(new UpdateGradeFeature(appCtx));
        this.menuItems.add(new CleanGradeFeature(appCtx));
        this.menuItems.add(new ShowCourseFeature());
    }

    @Override
    public String getItemName() {
        return "Manage grades";
    }

    @Override
    public String getBackItemName() {
        return "Back to main menu";
    }

    @Override
    public String getMenuHeader() {
        return "Manage grades\\n" +
                "     ---      \\n";
    }
}
`}</code></pre>
            <pre><code parentName="pre" {...{
                "className": "language-java",
                "metastring": "6:29 file=../src/main/java/com/netcompany/utils/StringUtils.java zoomIn=1.5",
                "6:29": true,
                "file": "../src/main/java/com/netcompany/utils/StringUtils.java",
                "zoomIn": "1.5"
              }}>{`package com.netcompany.utils;

import java.time.Instant;
import java.util.regex.Pattern;

public class StringUtils {
    static final Pattern decimalPattern = Pattern.compile("^\\\\d+(.\\\\d+)?$");

    public static String padRight(String s, int n) {
        return String.format("%-" + n + "s", s);
    }

    public static String padLeft(int value, int n) {
        return padLeft(String.valueOf(value), n);
    }

    public static String padLeft(String s, int n) {
        return String.format("%" + n + "s", s);
    }

    public static boolean isMatchedDecimalPattern(String decimalValue) {
        return decimalPattern.matcher(decimalValue).find();
    }

    public static String toEpocTimeString(long epochMilli) {
        return Instant.ofEpochMilli(epochMilli).toString();
    }
}
`}</code></pre>
          </CodeViewer>
        </div>
      </LayoutColumn>
    </WhiteColumnLayout>
    <hr></hr>
    <WhiteColumnLayout title={"The case study"} sizes={[3, 4]} mdxType="WhiteColumnLayout">
      <LayoutColumn mdxType="LayoutColumn">
        <h3>{`Conclusion`}</h3>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Well-organized project`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to locate the issue`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to comprehend and start coding`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to find and re-use a logic`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Loosing the coupling and increase cohesion`}</p>
          </li>
        </ul>
      </LayoutColumn>
      <LayoutColumn mdxType="LayoutColumn">
        <MermaidViewer mdxType="MermaidViewer">
          <pre><code parentName="pre" {...{
              "className": "language-mermaid"
            }}>{`classDiagram
  class Menu {
      <<interface>>
      +MenuItem[] menuItems
  }

  class MenuItem {
      <<interface>>
      +String itemName
  }

  class Service {
      <<interface>>
  }

  class Repository {
      <<interface>>
  }

  Menu--MenuItem
  Menu--Service
  MenuItem--Service
  Service--Repository
`}</code></pre>
          <pre><code parentName="pre" {...{
              "className": "language-mermaid"
            }}>{`classDiagram
    MainMenu--ManageCourseMenu
    MainMenu--ManageGradeMenu
    MainMenu--NewBalanceSheetMenu
    MainMenu--ManageBalanceSheetMenu

    ManageGradeMenu--CleanGradeFeature
    ManageGradeMenu--UpdateGradeFeature
    ManageGradeMenu--ShowCourseFeature
`}</code></pre>
        </MermaidViewer>
      </LayoutColumn>
    </WhiteColumnLayout>
    <hr></hr>
    <WhiteColumnLayout title={"The case study"} sizes={[3, 4]} mdxType="WhiteColumnLayout">
      <LayoutColumn mdxType="LayoutColumn">
        <h3>{`Conclusion`}</h3>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Well-organized project`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to locate the issue`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Easier to find and re-use a logic`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Loosing the coupling and increase cohesion`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Increase the complexity`}</p>
          </li>
        </ul>
      </LayoutColumn>
      <LayoutColumn mdxType="LayoutColumn">
        <div style={{
          objectFit: 'contain',
          overflow: "hidden",
          display: "flex",
          flexDirection: "row",
          flex: "1"
        }}>
  <img src={loc_analysis} alt="loc_analysis" />
        </div>
      </LayoutColumn>
    </WhiteColumnLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      